import React from 'react';
import { connect } from "react-redux";
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';


class ReplyDocument extends BaseDocument {
    constructor(props) {
        super(props);

        const { replyFields } = props.workflowItem;

        this.replyFormConfig = {
            currencyCode: this.props.contract.currency,
            fields: []
        };

        if (replyFields.ReplyAmount.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyAmount.label, editorType: 'dxNumberBox', dataField: 'amount', value: () => props.notification.totalprice });
        }
        if (replyFields.ReplyStatus.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyStatus.label, dataField: 'status', editorType: 'dxSelectBox', editorOptions: { dataSource: replyFields.ReplyStatus.quoteStatuses, valueExpr: 'value', displayExpr: 'display' } });
        }
        if (replyFields.ReplyComment.visible) {
            this.replyFormConfig.fields.push({ label: replyFields.ReplyComment.label, dataField: 'responsecomment', editorType: 'dxHtmlEditor' });
        }

        this.isAsiteEnabled = process.env.REACT_APP_ASITE_ENABLED === 'true';
    }

    renderForm = () => {
        return (
            <>
                <BiDynamicForm
                    isReply={true}
                    item={this.props.reply}
                    config={this.replyFormConfig}
                    valueChangeHandler={this.props.fieldChanged}
                    customFields={(this.props.customFieldsCommon || {}).RFQQUOTE_REPLY}
                />
            </>
        );
    }

    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType + 'Reply', this.props.notification.rfqquotationid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }

    render() {
        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.requestforquotereference}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    isReply={true}
                    customFields={(this.props.customFieldsCommon || {}).RFQQUOTE_REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.requestForQuote.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                    quoteref={this.props.notification.referenceid}
                />
            </>
        );

    }
}

const mapStateToProps = store => ({
    // globalResources: store.contract.template.resources,
    // contract: store.contract.contract,
});

export default injectIntl(connect(mapStateToProps)(ReplyDocument));
